module.exports = __webpack_public_path__ + "media/2x/7-61f275d6.png";